import { auth } from "../../../config/firebase";

// Base Pre Defined Workflows

// ocr a connector then run deasy prepare OOB tags
export const OCR_PREPARE = (data_connector_name) => {
  return {
    name: `Run OCR, Deasy Prepare, Tag Schema for ${data_connector_name}`,
    description: `Run OCR, Deasy Prepare, Tag Schema for ${data_connector_name} every day at midnight.`,
    status: "pending",
    created_at: new Date().toISOString(),
    updated_at: new Date().toISOString(),
    user_id: auth.currentUser.email,
    stages: [
      {
        status: "pending",
        jobs: [
          {
            id: `temp-${Date.now()}`,
            endpoint: "/ocr/ingest",
            status: "pending",
            endpoint_request_body: {
              data_connector_name: data_connector_name,
            },
          },
        ],
      },
      {
        status: "pending",
        jobs: [
          {
            id: `temp-${Date.now()}`,
            endpoint: "/prepare_data",
            status: "pending",
            endpoint_request_body: {
              data_connector_name: data_connector_name,
            },
          },
        ],
      },
    ],
    cadence: "0 0 * * *",
  };
};

// Just prepare data
export const PREPARE = (data_connector_name) => {
  return {
    name: `Run Deasy Prepare for ${data_connector_name}`,
    description: `Run Deasy Prepare for ${data_connector_name} every day at midnight.`,
    status: "pending",
    created_at: new Date().toISOString(),
    updated_at: new Date().toISOString(),
    user_id: auth.currentUser.email,
    stages: [
      {
        status: "pending",
        jobs: [
          {
            id: `temp-${Date.now()}`,
            endpoint: "/prepare_data",
            status: "pending",
            endpoint_request_body: {
              data_connector_name: data_connector_name,
            },
          },
        ],
      },
    ],
    cadence: "0 0 * * *",
  };
};

// Just classify data
export const CLASSIFY = (data_connector_name, schema_name) => {
  return {
    name: `Run Classification for ${data_connector_name}`,
    description: `Run Classification for ${data_connector_name} every day at midnight.`,
    status: "pending",
    created_at: new Date().toISOString(),
    updated_at: new Date().toISOString(),
    user_id: auth.currentUser.email,
    stages: [
      {
        status: "pending",
        jobs: [
          {
            id: `temp-${Date.now()}`,
            endpoint: "/classify_bulk",
            status: "pending",
            endpoint_request_body: {
              data_connector_name: data_connector_name,
              tag_names: [],
              hierarchy_name: schema_name,
              classification_mode: "schema",
            },
          },
        ],
      },
    ],
    cadence: "0 0 * * *",
  };
};

// ocr a connector then run deasy prepare OOB tags and then tag a schema
export const OCR_PREPARE_SCHEMA = (data_connector_name, schema_name) => {
  return {
    name: `Run OCR, Deasy Prepare, Tag Schema for ${data_connector_name}`,
    description: `Run OCR, Deasy Prepare, Tag Schema for ${data_connector_name} every day at midnight.`,
    status: "pending",
    created_at: new Date().toISOString(),
    updated_at: new Date().toISOString(),
    user_id: auth.currentUser.email,
    stages: [
      {
        status: "pending",
        jobs: [
          {
            id: `temp-${Date.now()}`,
            endpoint: "/ocr/ingest",
            status: "pending",
            endpoint_request_body: {
              data_connector_name: data_connector_name,
            },
          },
        ],
      },
      {
        status: "pending",
        jobs: [
          {
            id: `temp-${Date.now()}`,
            endpoint: "/prepare_data",
            status: "pending",
            endpoint_request_body: {
              data_connector_name: data_connector_name,
            },
          },
          {
            id: `temp-${Date.now()}`,
            endpoint: "/classify_bulk",
            status: "pending",
            endpoint_request_body: {
              data_connector_name: data_connector_name,
              tag_names: [],
              hierarchy_name: schema_name,
              classification_mode: "schema",
            },
          },
        ],
      },
    ],
    cadence: "0 0 * * *",
  };
};

// run deasy prepare OOB tags
export const PREPARE_TAG = (data_connector_name, schema_name) => {
  return {
    name: `Run Deasy Prepare, Tag Schema for ${data_connector_name}`,
    description: `Run Deasy Prepare, Tag Schema for ${data_connector_name} every day at midnight.`,
    status: "pending",
    created_at: new Date().toISOString(),
    updated_at: new Date().toISOString(),
    user_id: auth.currentUser.email,
    stages: [
      {
        status: "pending",
        jobs: [
          {
            id: `temp-${Date.now()}`,
            endpoint: "/prepare_data",
            status: "pending",
            endpoint_request_body: {
              data_connector_name: data_connector_name,
            },
          },
          {
            id: `temp-${Date.now()}`,
            endpoint: "/classify_bulk",
            status: "pending",
            endpoint_request_body: {
              data_connector_name: data_connector_name,
              tag_names: [],
              hierarchy_name: schema_name,
              classification_mode: "schema",
            },
          },
        ],
      },
    ],
    cadence: "0 0 * * *",
  };
};
